import styled from "styled-components";
import { JourneyBackground } from "./JourneyBackground";
import { JourneyIntroduction } from "./JourneyIntroduction";
import { JourneyCompanyAtGlance } from "./JourneyCompanyAtGlance";
import { RAButtonBackToTop, RAImage } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { JourneyCommitment } from "./JourneyCommitment";
import { CareerProgram, AvailablePositions, JoinOurTeam } from "./CareerProgram";
import { MainFooter } from "../../Footer/MainFooter";
import { useState, useEffect } from "react";

import { isEmpty } from "lodash";
import ReactFullpage from "@fullpage/react-fullpage";
import { JourneyMilestone } from "./JourneyMilestone";
import { useHeaderSolid } from "@/hooks/HeaderSolidContext";
const { useBreakpoint } = Grid;
const FULL_PAGE_API_KEY = process.env.NEXT_PUBLIC_FULL_PAGE_API_KEY;

export function ComponentJourneySnap({ pageContent = {}, desktop = true }) {
	const { headerSolid } = useHeaderSolid();
	const { content = {} } = pageContent;
	const { a_brief_history_of_royal_air } = content;
	const [activeSlide, setActiveSlide] = useState(0);
	const screens = useBreakpoint();
	const [scrollDirection, setScrollDirection] = useState(null);

	const onLeave = (origin, destination, direction) => {
		setActiveSlide(destination.index);
		headerSolid(destination.index);
		setScrollDirection(direction);
		if (direction === "up" && destination.index === 1) {
			setTimeout(function () {
				fullpage_api.moveTo(1);
				fullpage_api.moveSectionDown();
			});
		}
	};

	useEffect(() => {
		return () => {
			fullpage_api.silentMoveTo(1);
		};
	}, []);

	return (
		<>
			<div
				id="fixed-timeline-backgrounds"
				style={{
					width: "100%",
					height: "100%",
					position: "absolute",
					opacity:
						activeSlide >= 3 && activeSlide <= a_brief_history_of_royal_air?.timelines?.length + 2 ? 1 : 0,
					transition: "all 0.6s linear",
					top: 0,
					left: 0,
					zIndex:
						activeSlide >= 3 && activeSlide <= a_brief_history_of_royal_air?.timelines?.length + 2
							? -2
							: -3,
					background: "#fff",
				}}
			>
				{a_brief_history_of_royal_air?.timelines?.map((timeline, index) => {
					return (
						<div
							className="section"
							key={`timeline-image-${index}`}
							style={{
								height: "100%",
								width: "100%",
								position: "absolute",
								transition: "1s all linear",
								opacity: activeSlide === index + 3 ? 1 : 0,
							}}
						>
							<RAImage
								url={
									screens.md ? timeline?.desktop_background_photo : timeline?.mobile_background_photo
								}
								width="100%"
								height="100vh"
							/>
						</div>
					);
				})}
			</div>
			<div
				id="fixed-milestones"
				style={{
					width: "100%",
					height: "100%",
					position: "absolute",
					opacity:
						activeSlide >= 3 && activeSlide <= a_brief_history_of_royal_air?.timelines?.length + 2 ? 1 : 0,
					transition: "all 0.6s linear",
					top: 0,
					left: 0,
					zIndex:
						activeSlide >= 3 && activeSlide <= a_brief_history_of_royal_air?.timelines?.length + 2
							? -1
							: -2,
					background: "transparent",
				}}
			>
				<JourneyMilestone
					historyContent={a_brief_history_of_royal_air}
					active={activeSlide - 3}
					scrollDirection={scrollDirection}
				/>
			</div>
			{desktop ? (
				<ReactFullpage
					// navigation
					licenseKey={FULL_PAGE_API_KEY}
					bigSectionsDestination={"bottom"}
					onLeave={onLeave}
					scrollingSpeed={1100}
					fadingEffect={true}
					lazyLoading={false}
					normalScrollElements=".ant-picker-panel-container, .ant-modal, #snap-disabled, .ant-picker-time-panel-column, .mapboxgl-canvas, .ant-modal-wrap, .ra-search-airport-ant-select-dropdown"
					credits={{ enabled: false }}
					render={({ state, fullpageApi }) => {
						return (
							<ReactFullpage.Wrapper>
								<div className="section" id="hero-section">
									<JourneyBackground banner={content?.banner} />
								</div>
								<EachSlide className="section fp-auto-height">
									<BodyLargeContainer>
										<JourneyIntroduction
											introducing_you_to_royal_air={content?.introducing_you_to_royal_air}
										/>
									</BodyLargeContainer>
								</EachSlide>
								<EachSlide className="section" style={{ width: "100vw" }}>
									<div style={{ width: "100vw" }}>
										<JourneyCompanyAtGlance
											our_company_at_a_glance={content?.our_company_at_a_glance}
										/>
									</div>
								</EachSlide>
								{a_brief_history_of_royal_air?.timelines?.map((timeline, index) => {
									return <div className="section" key={`timeline-${index}`}></div>;
								})}
								<EachSlide className="section fp-auto-height">
									<LayoutOverlay>
										<BodyMediumContainer>
											<JourneyCommitment
												commitment_to_excellence={content?.commitment_to_excellence}
											/>
										</BodyMediumContainer>
									</LayoutOverlay>
								</EachSlide>

								<EachSlide className="section fp-noscroll">
									<BodyTravelCardContainer>
										<CareerProgram
											joining_our_team={content?.joining_our_team}
											available_positions={content?.available_positions}
										/>
									</BodyTravelCardContainer>
								</EachSlide>
								<EachSlide className="section fp-auto-height" id="footer-section">
									<footer
										style={{
											width: "100%",
											scrollSnapAlign: "end",
										}}
									>
										<MainFooter />
										<RAButtonBackToTop onClick={() => fullpage_api.moveTo(1)} />
									</footer>
								</EachSlide>
							</ReactFullpage.Wrapper>
						);
					}}
				/>
			) : (
				<ReactFullpage
					// navigation
					licenseKey={FULL_PAGE_API_KEY}
					bigSectionsDestination={"top"}
					onLeave={onLeave}
					scrollingSpeed={1100}
					fadingEffect={true}
					lazyLoading={false}
					normalScrollElements=".ant-picker-panel-container, .ant-modal, #snap-disabled, .ant-picker-time-panel-column, .mapboxgl-canvas, .ant-modal-wrap, .ra-search-airport-ant-select-dropdown"
					credits={{ enabled: false }}
					render={({ state, fullpageApi }) => {
						return (
							<ReactFullpage.Wrapper>
								<div className="section" id="hero-section">
									<JourneyBackground banner={content?.banner} />
								</div>
								<EachSlide className="section fp-auto-height">
									<BodyLargeContainer>
										<JourneyIntroduction
											introducing_you_to_royal_air={content?.introducing_you_to_royal_air}
										/>
									</BodyLargeContainer>
								</EachSlide>
								<EachSlide className="section" style={{ width: "100vw" }}>
									<div style={{ width: "100vw" }}>
										<JourneyCompanyAtGlance
											our_company_at_a_glance={content?.our_company_at_a_glance}
										/>
									</div>
								</EachSlide>
								{a_brief_history_of_royal_air?.timelines?.map((timeline, index) => {
									return <div className="section" key={`timeline-${index}`}></div>;
								})}
								<EachSlide className="section fp-auto-height">
									<LayoutOverlay>
										<BodyMediumContainer>
											<JourneyCommitment
												commitment_to_excellence={content?.commitment_to_excellence}
											/>
										</BodyMediumContainer>
									</LayoutOverlay>
								</EachSlide>

								<EachSlide className="section">
									<BodyTravelCardContainer>
										<JoinOurTeam joining_our_team={content?.joining_our_team} />
									</BodyTravelCardContainer>
								</EachSlide>
								<EachSlide className="section">
									<BodyTravelCardContainer>
										<AvailablePositions available_positions={content?.available_positions} />
									</BodyTravelCardContainer>
								</EachSlide>

								<EachSlide className="section fp-auto-height" id="footer-section">
									<footer
										style={{
											width: "100%",
											scrollSnapAlign: "end",
										}}
									>
										<MainFooter />
										<RAButtonBackToTop onClick={() => fullpage_api.moveTo(1)} />
									</footer>
								</EachSlide>
							</ReactFullpage.Wrapper>
						);
					}}
				/>
			)}
		</>
	);
}

const EachSlide = styled.div`
	width: 100vw;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const BodyMediumContainer = styled.div`
	max-width: 1442px;
	padding: 84px;
	width: 100%;

	@media (max-width: 991px) {
		padding: 44px;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;

const BodyLargeContainer = styled.div`
	max-width: 1442px;
	padding: 84px 136px;
	width: 100%;

	@media (max-width: 991px) {
		padding: 40px 80px;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;

const LayoutOverlay = styled.div`
	width: 100vw;
	height: 100%;
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	scroll-snap-align: start;
	background-image: url("/images/journey/Journey-BG-Web.png");
	background-repeat: no-repeat;
	background-size: cover;
	@media (max-width: 768px) {
		background-image: url("/images/journey/Journey-BG-Mobile.png");
	}
`;

const BodyTravelCardContainer = styled.div`
	max-width: 1442px;
	padding: 84px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	@media (max-width: 991px) {
		padding: 0 80px;
	}
	@media (max-width: 767px) {
		padding: 0 32px;
	}
	@media (max-width: 575px) {
		padding: 0 16px;
	}
`;
